import request from '../api/request'

// 分页查询考生组和考生信息
export function queryUserCanSignExams(param) {
    return request({
        url: '/exam/queryUserCanSignExams',
        method: 'get',
        params: param
    })
}


// 考生自主报名考试
export function signup(data) {
    return request({
        url: '/exam/signup',
        method: 'post',
        data: data
    })
}


// 查询学生报考信息
export function queryExamsByUserId(param) {
    return request({
        url: '/exam/queryExamsByUserId',
        method: 'get',
        params: param
    })
}

// 记录考试开始时间
export function recordAnswerTime(param) {
    return request({
        url: '/exam/recordAnswerTime',
        method: 'get',
        params: param
    })
}


// 查询试卷试题
export function paper(paperId) {
    return request({
        url: '/paper/' + paperId,
        method: 'get'
    })
}

// 提交考试结果
export function resultExam(data) {
    return request({
        url: '/result/resultExam',
        method: 'post',
        data: data
    })
}

// 分页查询试卷
export function queryExamResByUserId(param) {
    return request({
        url: '/result/queryExamRes',
        method: 'get',
        params: param
    })
}

